export default `
	created_at
	updated_at
	guid
	date
	transport_kind
	
	building {
		guid
	}
	
	license_plate {
		id
		license_plate
	}
`;
